<script>
    import { createEventDispatcher } from 'svelte';
    import date from '../lib/date';

    export let weekStartDate;
    let currentDate = new Date();

    let display_month = date.getMonth(currentDate);
    let display_year = date.getYear(currentDate);

    let isOpen = false;
    let element;

    const months = [
        'Leden', 'Únor', 'Březen',
        'Duben', 'Květen', 'Červen',
        'Červenec', 'Srpen', 'Září',
        'Říjen', 'Listopad', 'Prosinec'
    ];

    const dispatch = createEventDispatcher();

    // Get start date for month
    let startDate;
    $: rangeUpdated(display_month, display_year);

    function rangeUpdated(month, year) {
        let newStartDate = new Date(`${year}-${month + 1}-01`);

        // Week changed but the month did not!
        if (date.isSameDay(newStartDate, startDate)) return console.warn('isSameDay');

        startDate = newStartDate;
    }

    let weeks;
    $: weeks = render(startDate);
    function render(dateStart) {
        // Get last day of month
        let endDate = date.endOfMonth(dateStart);

        // Get days in range
        let days = date.eachDay(dateStart, endDate);

        // Prepare containers
        let weeks = [];
        let week = { days: [] };

        for (let day of days) {
            // Get current day of week
            let dow = date.getDay(day);

            // Got beginning of another week
            if (dow === 1 && week.days.length) {
                weeks.push( fillWeek(week) );
                week = { days: [] };
            }

            // Add the day to the current week
            week.days.push(day);
        }

        // Got a trailing week
        if (week.days.length) {
            weeks.push( fillWeek(week) );
        }

        return weeks;
    }

    function fillWeek(week) {
        if (!week || !week.days || !week.days.length) return false;

        // Get already defined days
        let days = week.days;

        // Get first day
        let day = days[0];

        // Already filled
        if (days.length === 7) return week;

        // Get days of week we already have
        let gotStart = date.getDay(days[0]);
        let gotEnd = date.getDay(days[days.length - 1]);

        // Fill left
        for (let i = 1; i < gotStart; i++) {
            days.splice(i - 1, 0, date.setDay(day, i));
        }

        // Fill right
        for (let i = gotEnd + 1; i <= 7; i++) {
            days.splice(i - 1, 0, date.setDay(day, i));
        }

        return week;
    }

    function getWeekDateRange(dateStart) {
        let dateEnd = date.endOfWeek(dateStart);

        return [
            date.format(dateStart, date.FORMAT_DATE_HUMAN),
            date.format(dateEnd, date.FORMAT_DATE_HUMAN)
        ].join(' - ');
    }

    let handler = null;
    $: handle(isOpen)
    function handle(state) {
        if (state) {
            handler = (e) => {
                if (!element.contains(e.target)) {
                    isOpen = false;
                }
            };

            document.addEventListener('click', handler);
        } else if (handler) {
            document.removeEventListener('click', handler);
        }
    }

    function onWeekClick(dateStart) {
        handle(isOpen = false);
        dispatch('week-selected', weekStartDate = dateStart);
    }

    function updateRange(dir) {
        display_month += dir;

        if (display_month < 0) {
            display_year--;
            display_month = 11;
        } else if (display_month > 11) {
            display_year++;
            display_month = 0;
        }
    }
</script>

<style>
    .week-select {
        cursor: pointer;
        display: inline-block;
        position: relative;
        padding: 5px;
        border: 1px solid #ececec;
    }

    .popup {
        cursor: auto;
        position: absolute;
        z-index: 99;
        top: 100%;
        left: 0;
        margin-top: 5px;
        padding: 8px;
        border: 1px solid #ececec;
        background: white;
        color: #333;
    }

    .week-select:not(._open) > .popup {
        display: none;
    }

    .popup-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
    }

    .popup-header .button {
        padding: 6px 10px;
        height: auto;
    }

    .popup-title {
        flex: 1;
        text-align: center;
        font-weight: bold;
    }

    .week {
        cursor: pointer;
        display: flex;
        flex-direction: row;
    }

    .week._active {
            background: rgba(0, 51, 255, 0.05);
    }

    .week:hover {
        background: #f5f5f5;
    }

    .day {
        width: 40px;
        height: 40px;
        line-height: 38px;
        text-align: center;
        border: 1px solid #ececec;
    }

    .day._diff-month {
        color: #cecece;
    }
</style>

<div class="week-select"
     bind:this={element}
     on:click|stopPropagation={() => isOpen = !isOpen}
     class:_open={isOpen}>
    <span class="week-text">{getWeekDateRange(weekStartDate)}</span>

    <div class="popup" on:click|stopPropagation>
        <div class="popup-header">
            <button class="button" on:click={() => updateRange(-1)}>
                <i class="fal fa-angle-left"></i>
            </button>
            <div class="popup-title">{months[display_month]} {display_year}</div>
            <button class="button" on:click={() => updateRange(1)}>
                <i class="fal fa-angle-right"></i>
            </button>
        </div>
        <div class="popup-weeks">
            {#each weeks as wk}
                <div class="week"
                     class:_active={date.isSameDay(weekStartDate, wk.days[0])}
                     on:click={() => onWeekClick(wk.days[0])}>
                    {#each wk.days as date}
                        <span
                            class="day"
                            class:_diff-month={date.getMonth() !== display_month}>
                            {date.getDate()}
                        </span>
                    {/each}
                </div>
            {/each}
        </div>
    </div>
</div>